/*
 * Error handlers
*/

export const handleApiErrors = (responseData) => {
  const errorMessages = responseData.messages
  let fieldError = []
  let sysError = []
  let feedbackError = [] 
  let errorList = {}

  if (errorMessages) {
    fieldError = errorMessages.filter(err => err.type === 'error_field')
    sysError = errorMessages.filter(err => err.type === 'error' || err.type === 'messages')
    feedbackError = errorMessages.filter(err => err.type === 'feedback')
  }

  errorList = {
    fieldError,
    sysError,
    feedbackError
  }

  return errorList
}